import { CancelToken } from 'axios'

import { TableUrlParams, TransformResponseType } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { PurchaseOrder } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<PurchaseOrder.Basic>> =>
	Http.get(baseUrl, { params })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<PurchaseOrder.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const retrievePurchaseOrderBalance = (): Promise<number> => Http.get(`${baseUrl}/balance`)

export const retrievePurchaseOrderStatuses = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/statuses`)

export const retrieveBillingLocationAddresses = (): Promise<
	PurchaseOrder.BillingLocationAddress[]
> => Http.get(`${baseUrl}/billing-location-addresses`)

export const addPurchaseOrder = (
	payload: PurchaseOrder.Request.Generic
): Promise<PurchaseOrder.Detailed> =>
	Http.post(baseUrl, payload, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})

export const editPurchaseOrder = (
	purchaseOrderId: Key,
	payload: PurchaseOrder.Request.Generic
): Promise<PurchaseOrder.Detailed> =>
	Http.put(`${baseUrl}/${purchaseOrderId}`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})

export const editPurchaseOrderWithHistory = (
	purchaseOrderId: Key,
	payload: PurchaseOrder.Request.WithHistory
): Promise<PurchaseOrder.Detailed> =>
	Http.put(`${baseUrl}/${purchaseOrderId}/with-history`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})

export const downloadPurchaseOrderFile = (purchaseOrderId: Key): Promise<TransformResponseType> =>
	Http.get(`${baseUrl}/${purchaseOrderId}/download/`, {
		responseType: 'blob',
		transformResponse: (data: Blob, headers) => ({
			data,
			headers
		})
	})

export const downloadPurchaseOrderHistoryFile = (
	purchaseOrderId: Key,
	fileId: Key
): Promise<TransformResponseType> =>
	Http.get(`${baseUrl}/${purchaseOrderId}/${fileId}/download`, {
		responseType: 'blob',
		transformResponse: (data: Blob, headers) => ({
			data,
			headers
		})
	})

export const retrievePurchaseOrder = (purchaseOrderId: Key): Promise<PurchaseOrder.Detailed> =>
	Http.get(`${baseUrl}/${purchaseOrderId}`)

export const retrievePurchaseOrderHistory = (
	purchaseOrderId: Key
): Promise<PurchaseOrder.History[]> => Http.get(`${baseUrl}/${purchaseOrderId}/history`)
